// neo_cogym — 카탈로그 클라이언트 (W8)
import { apiFetch, apiUrl } from "./client";
import type { ContentAsset, ContentType } from "../content/types";

export interface CourseSummary {
  id: string;
  slug: string;
  title: string;
  description: string | null;
}

export interface LessonDetail {
  id: string;
  kind: string;
  title: string;
  position: number;
  codingEnv: string | null;
  contents: {
    id: string;
    type: ContentType;
    title: string;
    src: string | null; // 미수강 시 null(locked)
    meta: ContentAsset["meta"];
    locked: boolean;
  }[];
}

export interface CourseDetail {
  courseId: string;
  entitled: boolean;
  product: { id: string; amountMinor: number; currency: string } | null;
  lessons: LessonDetail[];
}

export function getCourses(): Promise<{ courses: CourseSummary[] }> {
  return apiFetch("/api/courses");
}

export function getCourse(id: string): Promise<CourseDetail> {
  return apiFetch(`/api/courses/${id}`);
}

/** LessonDetail 의 콘텐츠를 ContentPane 의 ContentAsset 으로 변환(수강권 있을 때만) */
export function toContentAsset(lessonId: string, c: LessonDetail["contents"][number]): ContentAsset | null {
  if (!c.src) return null;
  // 상대 경로(/content/...)는 Worker 오리진(API_BASE) 기준 절대 URL 로. 절대(Stream HLS)는 그대로.
  const src = c.src.startsWith("/") ? apiUrl(c.src) : c.src;
  return { id: c.id, lessonId, type: c.type, title: c.title, src, meta: c.meta };
}
